import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import PageHeader from '../../../shared/page-header/components/page-header';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import DateRangeSelector from '../../../shared/date-range-selector/components/date-range-selector';
import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import RenderIf from '../../../shared/render-if/components/render-if';
import Pagination from '../../../shared/pagination/components/pagination';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import ClientsTable from './clients-table';
import ConvertUserModal from './convert-user-modal';
import ExportTableModal from './export-table-modal';
import constants from '../../../../common/constants';
import registerConstants from '../../register/constants/register-constants';
import { getClients, toggleExportTableModal } from '../actions/clients-actions';

import '../styles/clients.css';

class Clients extends Component {
  state = {
    startDate: moment(constants.initial_app_date),
    endDate: moment(),
    accountType: constants.account_types.demo,
    limit: 5,
    page: 0,
  };

  componentDidMount() {
    const { startDate, endDate, limit, page, accountType } = this.state;

    this.handleGetClients(startDate, endDate, limit, page, accountType.value);
  }

  onAccountTypeChange(item) {
    const { startDate, endDate, limit, page } = this.state;

    this.handleGetClients(startDate, endDate, limit, page, item.value);
    this.setState({ accountType: item });
  }

  handleDateChange(startDate, endDate) {
    const { limit, page, accountType } = this.state;

    this.handleGetClients(startDate, endDate, limit, page, accountType.value);
    this.setState({ startDate, endDate });
  }

  handlePageChange(page) {
    const { startDate, endDate, limit, accountType } = this.state;

    this.handleGetClients(startDate, endDate, limit, page, accountType.value);
    this.setState({ page });
  }

  handleGetClients(startDate, endDate, limit, page, accountType) {
    const { getClients } = this.props;

    getClients(startDate, endDate, limit, page, accountType);
  }

  export(isOnlineAffiliate, type) {
    const { getClients, count } = this.props;
    const { accountType } = this.state;

    getClients(moment(constants.initial_app_date), moment(), count, 0, accountType.value, true, isOnlineAffiliate, type);
  }

  showExportTableModal() {
    const { toggleExportTableModal } = this.props;

    toggleExportTableModal(true);
  }

  render() {
    const { t } = this.context;
    const { startDate, endDate, page, limit } = this.state;
    const { clients, count, httpInProgress, profile } = this.props;
    const accountTypes = _.values(constants.account_types);
    const pages = count <= limit ? 1 : Math.ceil(count / limit);
    const isOnlineAffiliate = profile && profile.user_type === registerConstants.user_types.affiliate;

    return (
      <div className="clients-container">
        <ConvertUserModal />
        <ExportTableModal isOnlineAffiliate={isOnlineAffiliate} exportCallback={this.export.bind(this)} />
        <PageHeader title={'CLIENTS.TITLE'} />
        <div className="clients-container__header row">
          <div className="col-md-4">
            <p className="default-label">{t('CLIENTS.ACCOUNT_TYPE')}</p>
            <ButtonsSelector items={accountTypes} selectedValue={constants.account_types.demo} onClick={item => this.onAccountTypeChange(item)} />
          </div>
          <div className="col-md-6">
            <p className="default-label">{t('CLIENTS.DATE_RANGE')}</p>
            <DateRangeSelector startDate={startDate} endDate={endDate} onChange={values => this.handleDateChange(values)} />
          </div>
          <div className="col-md-2 print-button-wrapper">
            <div className={`transparent-btn ${clients && clients.length === 0 ? 'transparent-btn-disabled' : ''}`} onClick={() => this.showExportTableModal()}>
              {t('CLIENTS.EXPORT_TO_CSV')}
            </div>
          </div>
        </div>
        <div className="clients-container__body">
          <RenderIf if={!clients || httpInProgress}>
            <div className="display-flex-center p-t-50 p-b-50">
              <DefaultLoader />
            </div>
          </RenderIf>
          <RenderIf if={!httpInProgress && clients && clients.length > 0}>
            <ClientsTable isOnlineAffiliate={isOnlineAffiliate} profile={profile} />
          </RenderIf>
          <RenderIf if={!httpInProgress && clients && clients.length === 0}>
            <EmptyState title={'CLIENTS.NO_CLIENTS_MESSAGE'} />
          </RenderIf>
          <RenderIf if={clients && clients.length > 0}>
            <div className="display-flex-center">
              <Pagination activePage={page} count={pages} disabled={httpInProgress} setPage={currentPage => this.handlePageChange(currentPage)} />
            </div>
          </RenderIf>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  clients: state.clientsReducer.clients,
  count: state.clientsReducer.count,
  profile: state.userProfileReducer.profile,
  httpInProgress: state.httpInProgressReducer.httpInProgress,
});

const mapDispatchToProps = dispatch => ({
  getClients: (dateFrom, dateTo, limit, page, accountType, isExport, isOnlineAffiliate, type) => {
    dispatch(getClients(dateFrom, dateTo, limit, page, accountType, isExport, isOnlineAffiliate, type));
  },
  toggleExportTableModal: show => {
    dispatch(toggleExportTableModal(show));
  },
});

Clients.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Clients);



// WEBPACK FOOTER //
// ./src/app/main/clients/components/clients.js